module.exports = __webpack_public_path__ + "3d30659eeb42c31fb3f56478641dddab.png";